import React from "react";
import RegisterHeader from "src/features/organization/components/RegisterHeader";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import rehypeSlug from "rehype-slug";
import { useTranslation } from "react-i18next";

function CookiesPolicy() {
  const [content, setContent] = React.useState("");
  const { i18n } = useTranslation();
  const locale = i18n.language || "en";

  React.useEffect(() => {
    fetch(`/legal/${locale}/cookies.md`)
      .then((res) => (res.ok ? res : fetch("/legal/en/cookies.md")))
      .then((res) => res.text())
      .then(setContent)
      .catch(() =>
        fetch("/legal/en/cookies.md")
          .then((r) => r.text())
          .then(setContent)
      );
  }, [locale]);

  return (
    <div className="flex flex-1 min-h-screen">
      <RegisterHeader />
      <div className="flex-1 px-20">
        <div className="markdown-content">
          <ReactMarkdown
            remarkPlugins={[remarkGfm]}
            rehypePlugins={[rehypeSlug]}
          >
            {content}
          </ReactMarkdown>
        </div>
      </div>
    </div>
  );
}

export default React.memo(CookiesPolicy);
